import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

// Environment Vars
import { environment } from '../../environments/environment';

/**
 * This interceptor adds a X-ContextId header to all requests
 * helpful when debugging and identifiying traffic to our APIs
 *
 * @class
 *
 */
@Injectable()
export class HttpSwimlaneInterceptor implements HttpInterceptor {

  private uuidService = require('uuid/v4');

  /**
   * Intercepter that will memoize HTTP requests and store the results
   * @param {HttpRequest} req - the http request being executed
   * @param {HttpHandler} next - the next step in the http chain
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // strip white space and hyphen from guid
    const uuid = this.uuidService().replace(/-|\s/g, '');

    // Clone the request and replace the original headers with
    // cloned headers, updated with a X-ContextId.
    const authReq = req.clone({
      headers: req.headers.set('X-ContextId', `${uuid},${environment.SWIMLANE_NAME}`)
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq);

  }
}